import { render, staticRenderFns } from "./DetailPageMaintenanceList.vue?vue&type=template&id=381c667a&scoped=true"
import script from "./DetailPageMaintenanceList.vue?vue&type=script&lang=js"
export * from "./DetailPageMaintenanceList.vue?vue&type=script&lang=js"
import style0 from "./DetailPageMaintenanceList.vue?vue&type=style&index=0&id=381c667a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381c667a",
  null
  
)

export default component.exports